import { currencyConfig } from "@/shared/checkout/currency-settings";

// Currencies whose prices are displayed excluding VAT.
export const EXCL_VAT_CURRENCIES = ["EUR", "GBP", "SEK"];

// A currency supports the Cybersource payment processor when its checkout config defines a
// billing data area mapping (see `currencyConfig` in shared/checkout).
export const isCybersourceSupportedCurrency = (currencyCode: string): boolean =>
  currencyConfig[currencyCode]?.billingDataAreaId != null;
